import Carousel from './carousel';

const GALLERY_OPTIONS = {
    cellSelector: '.gallery__slide',
    cellAlign: 'left',
    contain: true,
    wrapAround: true,
    pageDots: true,
    prevNextButtons: true,
    imagesLoaded: true,
};

class Gallery {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.carousel = null;
    }

    init() {
        let self = this;

        if (!self.elem) return self;

        self.carousel = new Carousel(self.elem, GALLERY_OPTIONS).init();
        return self;
    }
}

export default Gallery;
